<template>
    <main class="smaller-padding data-table">
        <v-data-table
            :headers="headers"
            :items="list"
            :total-items="30"
            :loading="loading"
            :pagination.sync="sync"
            :hide-actions="true"
            :must-sort="true"
            no-data-text="Sem dados"
            no-results-text="Sem dados"
            sort-icon="mdi-chevron-down"
        >
            <v-progress-linear
                slot="progress"
                :color="providerColor"
                indeterminate
            />

            <template slot="items" slot-scope="props">
                <app-access-table-item
                    :data-item="props.item"
                ></app-access-table-item>
            </template>
        </v-data-table>

        <v-pagination
            v-if="totalPages"
            v-model="sync.page"
            color="primary"
            :total-visible="7"
            :length="totalPages"
            @input="setPage"
        ></v-pagination>
    </main>
</template>

<script>
import EventBus from "@packages/event-bus";
import paginatedTable from "@mixins/paginated-table";
import AppAccessTableItem from "./components/AccessTableItem";
import provider from "@mixins/provider";

export default {
    components: {
        AppAccessTableItem,
    },

    data() {
        return {
            entity: "access",
            headers: [
                { text: "Data", value: "data" },
                { text: "Aparelho", value: "nomeAparelho" },
                { text: "E-mail/Telefone", value: "email" },
                { text: "Data Nascimento/Sexo", value: "dataNascimento" },
                { text: "IP/MAC", value: "ipLocal" },
                { text: "Liberado", value: "dataLiberacao" },
            ],
        };
    },

    mixins: [paginatedTable, provider],

    mounted() {
        EventBus.$on("LOAD_PROMOCIONAL_CODE", this.load);
    },

    beforeDestroy() {
        EventBus.$on("LOAD_PROMOCIONAL_CODE", this.load);
    },
};
</script>

<style scoped>
.used-filter {
    width: 400px;
    display: block;
    margin-top: 10px;
    margin-left: auto;
    margin-right: auto;
}
</style>
